/**
 * El texto de un CSV: UTF-8 y, si trae caracteres rotos y no queda ni un no ASCII
 * válido, Windows-1252 (el «ANSI» de Excel en español). Misma regla que el
 * backend (`textoDelCsv` en carga-catalogo/leer-archivo.ts). Se decodifica con la
 * tabla, no con TextDecoder('windows-1252'): en algunos entornos cae como latin1.
 */
const MAPEO_WINDOWS_1252: Readonly<Record<number, number>> = {
  0x80: 0x20ac,
  0x82: 0x201a,
  0x83: 0x192,
  0x84: 0x201e,
  0x85: 0x2026,
  0x86: 0x2020,
  0x87: 0x2021,
  0x88: 0x2c6,
  0x89: 0x2030,
  0x8a: 0x160,
  0x8b: 0x2039,
  0x8c: 0x152,
  0x8e: 0x17d,
  0x91: 0x2018,
  0x92: 0x2019,
  0x93: 0x201c,
  0x94: 0x201d,
  0x95: 0x2022,
  0x96: 0x2013,
  0x97: 0x2014,
  0x98: 0x2dc,
  0x99: 0x2122,
  0x9a: 0x161,
  0x9b: 0x203a,
  0x9c: 0x153,
  0x9e: 0x17e,
  0x9f: 0x178,
};

export function decodificarWindows1252(bytes: Uint8Array): string {
  const codigos = new Uint16Array(bytes.length);
  for (let i = 0; i < bytes.length; i++) codigos[i] = MAPEO_WINDOWS_1252[bytes[i]] ?? bytes[i];
  // utf-16le no depende de la tabla de codificaciones del entorno.
  return new TextDecoder('utf-16le').decode(codigos);
}

export function textoDelCsv(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  const utf8 = new TextDecoder('utf-8').decode(bytes);
  if (!utf8.includes('�')) return utf8.replace(/^\uFEFF/, '');
  const sinRoto = utf8.replace(/�/g, '');
  // Mezcla de UTF-8 válido con bytes rotos: se deja el UTF-8 (el backend avisa).
  if (Array.from(sinRoto).some((c) => c.charCodeAt(0) > 127)) return utf8;
  return decodificarWindows1252(bytes);
}
